/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { HangerSpecificationFamilyInformation } from '../../components/add-family-information/hanger-specification-family-information';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class HangerSpecificationFamilyInformationDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = HangerSpecificationFamilyInformation;
    sysquePopupConfig.width = 750;
      sysquePopupConfig.height = 685;
    sysquePopupConfig.componentTitle = '';
    sysquePopupConfig.visible = true;
  }
}